import React from "react";
import { observer } from "mobx-react";
import { ShowcaseWorkflowStateCreateStore } from "../../store";
import { ShowcaseWorkflowStateCreateForm } from "./ShowcaseWorkflowStateCreateForm";
import { ErrorDialog } from "../../../../common/controls";
import { SavingOverlay } from "../../../../common/controls/forms/SavingOverlay";

export type ShowcaseWorkflowStateCreateProps = {
  showcaseWorkflowStateCreateStore: ShowcaseWorkflowStateCreateStore;
  showToolbox?: boolean;
  showSaveFooter?: boolean;
};

export const ShowcaseWorkflowStateCreate: React.FC<ShowcaseWorkflowStateCreateProps> =
  observer(
    ({
      showcaseWorkflowStateCreateStore,
      showToolbox = true,
      showSaveFooter,
    }) => {
      return (
        <>
          <SavingOverlay open={showcaseWorkflowStateCreateStore.isSaving} />
          <ShowcaseWorkflowStateCreateForm
            showcaseWorkflowStateCreateStore={showcaseWorkflowStateCreateStore}
            name_esError={
              showcaseWorkflowStateCreateStore.errors.name_es?.message
            }
            onName_esChange={(value: string) => {
              showcaseWorkflowStateCreateStore.setName_esValue(value);
            }}
            name_es={showcaseWorkflowStateCreateStore.entityValues.name_es}
            name_enError={
              showcaseWorkflowStateCreateStore.errors.name_en?.message
            }
            onName_enChange={(value: string) => {
              showcaseWorkflowStateCreateStore.setName_enValue(value);
            }}
            name_en={showcaseWorkflowStateCreateStore.entityValues.name_en}
            name_ptError={
              showcaseWorkflowStateCreateStore.errors.name_pt?.message
            }
            onName_ptChange={(value: string) => {
              showcaseWorkflowStateCreateStore.setName_ptValue(value);
            }}
            name_pt={showcaseWorkflowStateCreateStore.entityValues.name_pt}
            showToolbox={showToolbox}
            showSaveFooter={showSaveFooter}
            saving={showcaseWorkflowStateCreateStore.isProcessing}
            onSave={() =>
              showcaseWorkflowStateCreateStore.saveNewShowcaseWorkflowState()
            }
            onCancel={() =>
              showcaseWorkflowStateCreateStore.cancelNewShowcaseWorkflowState()
            }
          />
          <ErrorDialog
            open={showcaseWorkflowStateCreateStore.errorDialogOpened}
            title={showcaseWorkflowStateCreateStore.errorTitle}
            description={showcaseWorkflowStateCreateStore.errorDescription}
            onClose={() => showcaseWorkflowStateCreateStore.closeErrorDialog()}
          />
        </>
      );
    }
  );
